import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Link from "./link"
import { htmlDecode } from "../Utils"

const InstagramFeed = ({
  key,
  heading=null,
  content=null
}) => {
  return (
    <StaticQuery
      query={graphql`
        query InstagramFeed {
          strapiInstagramFeed {
            feed {
              id
              timestamp
              media_type
              media_url
              permalink
              thumbnail_url
              caption
            }
          }
        }
      `}
      render={data => (
        <div className="instagram_feed">
          <div className="container">
            <div className="col-12 col-md-10 offset-md-1">
              <div className="row">
                <div className="col">
                  <div id="sb_instagram" className="sbi sbi_col_4 sbi_width_resp" style={{paddingBottom: '10px', width: '100%'}}>
                    <div className="sb_instagram_header " style={{padding: '5px', marginBottom: '10px', paddingBottom: 0}}>
                      <Link href="https://www.instagram.com/hc1dotcom/" target="_blank" rel="noopener nofollow" title="@hc1dotcom" className="sbi_header_link">
                        <div className="sbi_header_text">
                          <h3>hc1dotcom</h3>
                          <p className="sbi_bio">The leader in critical insight, analytics, and solutions for precision health.</p>
                        </div>
                        <div className="sbi_header_img" data-avatar-url={`/images/hc1dotcom.jpeg`}>
                          <div className="sbi_header_img_hover"><svg className="sbi_new_logo fa-instagram fa-w-14" aria-hidden="true" data-fa-processed aria-label="Instagram" data-prefix="fab" data-icon="instagram" role="img" viewBox="0 0 448 512">
                              <path fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                            </svg></div>
                          <img src={`/images/hc1dotcom.jpeg`} alt="hc1" width={50} height={50} />
                        </div>
                      </Link>
                    </div>
                    <div id="sbi_images" style={{padding: '5px'}}>
                      {data.strapiInstagramFeed.feed && data.strapiInstagramFeed.feed.map((post, index) => (
                        <>
                          {post.media_type !== 'VIDEO' &&
                            <div className="sbi_item sbi_type_image" id={ `sbi_${post.id}` } data-date={ post.timestamp } style={{display: (index > 3) ? "none" : "block"}}>
                              <div className="sbi_photo_wrap">
                                <a className="sbi_photo sbi_imgLiquid_bgSize sbi_imgLiquid_ready" href={ post.permalink } target="_blank" rel="noopener nofollow" style={{height: '262.5px', backgroundImage: `url("${post.media_url}")`, backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', opacity: 1}}>
                                  <span className="sbi-screenreader">{ htmlDecode(post.caption) }</span>
                                  <img src={ post.media_url } alt={ htmlDecode(post.caption) } style={{display: 'none'}} />
                                </a>
                              </div>
                            </div>
                          }
                          {post.media_type === 'VIDEO' &&
                            <div className="sbi_item sbi_type_video" id={ `sbi_${post.id}` } data-date={ post.timestamp } style={{display: (index > 3) ? "none" : "block"}}>
                              <div className="sbi_photo_wrap">
                                <a className="sbi_photo sbi_imgLiquid_bgSize sbi_imgLiquid_ready" href={ post.permalink } target="_blank" rel="noopener nofollow" style={{height: '262.5px', backgroundImage: `url("${post.thumbnail_url}")`, backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', opacity: 1}}>
                                  <span className="sbi-screenreader">{ htmlDecode(post.caption) }</span>
                                  <svg style={{color: 'rgba(255,255,255,1)'}} className="svg-inline--fa fa-play fa-w-14 sbi_playbtn" aria-label="Play" aria-hidden="true" data-fa-processed data-prefix="fa" data-icon="play" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z" /></svg>
                                  <img src={ post.thumbnail_url } alt={ htmlDecode(post.caption) } style={{display: 'none'}} />
                                </a>
                              </div>
                            </div>
                          }
                        </>
                      ))}
                    </div>
                    <div id="sbi_load">
                      {data.strapiInstagramFeed.feed.length > 4 &&
                        <button className="sbi_load_btn" data-index="1">
                          <span className="sbi_btn_text">Load More...</span>
                          <span className="sbi_loader sbi_hidden" style={{backgroundColor: 'rgb(255, 255, 255)'}} aria-hidden="true" />
                        </button>
                      }
                      <span className="sbi_follow_btn">
                        <Link href="https://www.instagram.com/hc1dotcom/" target="_blank" rel="noopener nofollow"><svg className="svg-inline--fa fa-instagram fa-w-14" aria-hidden="true" data-fa-processed aria-label="Instagram" data-prefix="fab" data-icon="instagram" role="img" viewBox="0 0 448 512">
                            <path fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                          </svg>Follow on Instagram</Link>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    />
  )
}

export default InstagramFeed
